import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Column,
  FlexBox,
  AlertBox,
  H2,
  Typography,
  GridContainer,
  Link,
} from '@vp/swan';
import get from 'lodash/get';
import { useTranslations, ReplaceTokens } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';

const OrderDetailsLink = ({ children }) => {
  const { externalAppNavigation: nav } = useSiteData();
  const orderDetailsUrl = nav.orderDetails;
  return <Link href={orderDetailsUrl}>{children}</Link>;
};
OrderDetailsLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const OrderHistoryLink = ({ children }) => {
  const { externalAppNavigation: nav } = useSiteData();
  const orderHistoryUrl = nav.orderHistory;
  return <Link href={orderHistoryUrl}>{children}</Link>;
};
OrderHistoryLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

// A map of error status to i18n errorMessages Translation Group keys.
const errorMap = {
  // 400 BAD REQUEST - Missing email or doesn't match email on order
  400: {
    errorTitleKey: 'orderNotFoundErrorTitle',
    errorMessageDetailsKey: 'orderNotFoundBadRequestErrorDetails',
  },
  // 403 FORBIDDEN - Anonymous access denied for non-anonymous user or tenant
  403: {
    errorTitleKey: 'anonymousForbiddenTitle',
    errorMessageDetailsKey: 'anonymousForbiddenDetails',
  },
  // 404 NOT FOUND - Order not found
  404: {
    errorTitleKey: 'orderNotFoundErrorTitle',
    errorMessageDetailsKey: 'orderNotFoundBadRequestErrorDetails',
  },
  default: {
    errorTitleKey: 'defaultErrorTitle',
    errorMessageDetailsKey: 'defaultErrorDetails',
  },
};

// This is a temporary solution for error handling until proper error pages exist
const ErrorHandler = ({ error = {} }) => {
  const status = error?.response?.data?.status;
  const [errorMessages] = useTranslations(['errorMessages']);
  const computedError = get(errorMap, status, errorMap.default);
  return (
    <GridContainer>
      <Row my={9}>
        <Column span={12}>
          <FlexBox
            mt={5}
            mb={7}
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            {/* Need to display error code, message, contact? */}
            <AlertBox skin="error">
              <H2 fontSize="small">
                {errorMessages[computedError.errorTitleKey]}
              </H2>
            </AlertBox>
            <Typography>
              <ReplaceTokens
                tokenizedString={
                  errorMessages[computedError.errorMessageDetailsKey]
                }
                substitutions={{ OrderDetailsLink, OrderHistoryLink }}
              />
            </Typography>
            {/* need a call to action for the default status */}
          </FlexBox>
        </Column>
      </Row>
    </GridContainer>
  );
};

export default ErrorHandler;

ErrorHandler.propTypes = {
  error: PropTypes.object,
};
